export const transportConfigs = [
  // palette
  {
    type: "palette",
    title: "transportConfigs.palette.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.palette.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Euro-Palette (EPAL)",
          "Industriepalette",
          "Einwegpalette",
          "Gitterbox",
          "Sonderpalette",
          "Andere",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.palette.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.palette.fields.total_weight",
        type: "number",
      },
    ],
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: false,
  },

  // pakete
  {
    type: "pakete",
    title: "transportConfigs.pakete.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.pakete.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Small Package (S)",
          "Medium Package (M)",
          "Large Package (L)",
          "Extra Large Package (XL)",
          "Document",
          "Warenpaket",
          "Sonstiges (Other)",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.other.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.pakete.fields.item_weight",
        type: "number",
      },
      // {
      //   name: "content_pakage",
      //   label: "transportConfigs.pakete.fields.content_pakage",
      //   type: "text",
      // },
    ],
    hasDimensions: true,
    hasFragile: true,
    hasSpecialHandling: true,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: false,
  },

  // document
  {
    type: "document",
    title: "transportConfigs.document.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.document.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Dokument",
          "Ordner",
          "Vertrag",
          "Brief",
          "Paket (falls relevant)",
          "Sonstiges",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.document.fields.num_items",
        type: "number",
      },
    ],
    hasItemSecret: true,
    hasSignature: true,
    hasDimensions: false,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: false,
  },

  // furniture
  {
    type: "furniture",
    title: "transportConfigs.furniture.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.furniture.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Sofa",
          "Couch",
          "Sessel",
          "Stuhl",
          "Esstisch",
          "Wohnzimmertisch",
          "Schreibtisch",
          "Beistelltisch",
          "Couchtisch",
          "Nachttisch",
          "Bett",
          "Bettgestell",
          "Matratze",
          "Lattenrost",
          "Schrank",
          "Kleiderschrank",
          "Vitrine",
          "Kommode",
          "Regal",
          "Bücherregal",
          "Fernsehschrank",
          "TV-Board",
          "Sideboard",
          "Hängeschrank",
          "Küchenschrank",
          "Esstischstuhl",
          "Barhocker",
          "Garderobe",
          "Spiegel",
          "Teppich",
          "Lampenständer",
          "Blumentisch",
          "Gartenmöbel",
          "Liegestuhl",
          "Balkonmöbel",
          "Kinderbett",
          "Wickeltisch",
          "Bürostuhl",
          "Bürotisch",
          "Aktenschrank",
          "Rollcontainer",
          "Konferenztisch",
          "Schreibtischstuhl",
          "Werkbank",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.furniture.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.furniture.fields.item_weight",
        type: "number",
      },
    ],
    hasDimensions: true,
    hasFragile: true,
    hasSpecialHandling: true,
    hasHelpCarry: true,
    hasFloors: true,
    hasDriving: false,
  },

  // electrical
  {
    type: "electrical",
    title: "transportConfigs.electrical.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.electrical.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Waschmaschine",
          "Trockner",
          "Waschtrockner",
          "Geschirrspüler",
          "Kühlschrank",
          "Gefrierschrank",
          "Backofen",
          "Herd",
          "Elektroherd",
          "Gasherd",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.electrical.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.electrical.fields.total_weight",
        type: "number",
      },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: false,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: true,
    hasFloors: true,
    hasDriving: false,
  },

  // tires
  {
    type: "tires",
    title: "transportConfigs.tires.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.tires.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Sommerreifen",
          "Winterreifen",
          "Ganzjahresreifen",
          "PKW Reifen",
          "SUV Reifen",
          "Transporter Reifen",
          "Motorradreifen",
          "Felgen + Reifen",
          "Nur Felgen",
          "Reifen mit Felgen",
          "Sonstiges",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.tires.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.tires.fields.total_weight",
        type: "number",
      },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: false,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: true,
    hasFloors: true,
    hasDriving: false,
  },

  // motorcycle
  {
    type: "motorcycle",
    title: "transportConfigs.motorcycle.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.motorcycle.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Motorrad",
          "Leichtkraftrad",
          "Kleinkraftrad",
          "Moped",
          "Mofa",
          "Leichtmotorrad",
          "Motorroller",
          "E-Roller",
          "E-Motorrad",
          "Elektro-Motorrad",
          "Enduro",
          "Cross",
          "Supermoto",
          "Naked Bike",
          "Streetfighter",
          "Sportbike",
          "Superbike",
          "Supersportler",
          "Touring Bike",
          "Reiseenduro",
          "Adventure Bike",
          "Cruiser",
          "Chopper",
          "Custom Bike",
          "Bobber",
          "Retro Bike",
          "Cafe Racer",
          "Scrambler",
          "Trike",
          "Quad",
          "ATV",
          "Pocket Bike",
          "Minibike",
          "Motocross",
          "Offroad Bike",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.motorcycle.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.motorcycle.fields.item_weight",
        type: "number",
      },
    ],
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: true,
  },

  // refrigerator
  {
    type: "refrigerator",
    title: "transportConfigs.refrigerator.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.refrigerator.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Kühlschrank",
          "Gefrierschrank",
          "Kühl-Gefrierkombination",
          "Minikühlschrank",
          "Weinkühlschrank",
          "Gefriertruhe",
          "Waschmaschine",
          "Trockner",
          "Waschtrockner",
          "Geschirrspüler",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.refrigerator.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.refrigerator.fields.total_weight",
        type: "number",
      },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: true,
    hasFloors: true,
    hasDriving: false,
  },

  // animals
  {
    type: "animal transport",
    title: "transportConfigs.animal_transport.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.animal_transport.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Hund",
          "Katze",
          "Kleintierkäfig",
          "Kaninchen",
          "Hamster",
          "Meerschweinchen",
          "Vogel",
          "Papagei",
          "Wellensittich",
          "Reptil",
          "Schildkröte",
          "Schlange",
          "Fischbecken",
          "Aquarium",
          "Pferd",
          "Pony",
          "Esel",
          "Ziege",
          "Schaf",
          "Kalb",
          "Kuh",
          "Schwein",
          "Huhn",
          "Hahn",
          "Gans",
          "Ente",
          "Truthahn",
          "Taube",
          "Tierbox",
          "Tierkäfig",
          "Transportbox",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.animal_transport.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.animal_transport.fields.total_weight",
        type: "number",
      },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: false,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: true,
    hasFloors: true,
    hasDriving: false,
  },

  // building materials
  {
    type: "building materials",
    title: "transportConfigs.building_materials.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.building_materials.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Zement",
          "Sandsäcke",
          "Kies",
          "Betonplatten",
          "Steine",
          "Ziegel",
          "Backsteine",
          "Bausteine",
          "Gipskartonplatten",
          "Holzbalken",
          "Bretter",
          "Dachziegel",
          "Rohre",
          "Metallstangen",
          "Kupferrohre",
          "PVC-Rohre",
          "Isolationsmaterial",
          "Farben",
          "Eimer mit Farbe",
          "Putzsäcke",
          "Bauschutt",
          "Palettenware",
          "Baumaterial allgemein",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.building_materials.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.building_materials.fields.total_weight",
        type: "number",
      },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: false,
  },

  // other
  {
    type: "other",
    title: "transportConfigs.other.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.other.fields.item_type",
        type: "text",
        required: true,
        // options: [
        //   "transportConfigs.other.fields.options.Euro",
        //   "transportConfigs.other.fields.options.Industrial",
        //   "transportConfigs.other.fields.options.Other",
        // ],
      },
      {
        name: "num_items",
        label: "transportConfigs.other.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.other.fields.total_weight",
        type: "number",
      },
      // {
      //   name: "item_weight",
      //   label: "transportConfigs.moving.fields.item_weight",
      //   type: "number",
      // },
      // {
      //   name: "item_length",
      //   label: "transportConfigs.moving.fields.item_length",
      //   type: "number",
      // },
      // {
      //   name: "item_width",
      //   label: "transportConfigs.moving.fields.item_width",
      //   type: "number",
      // },
      // {
      //   name: "item_height",
      //   label: "transportConfigs.moving.item_height",
      //   type: "number",
      // },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: false,
  },

  // car
  {
    type: "car",
    title: "transportConfigs.car.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.car.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Toyota",
          "Volkswagen",
          "Mercedes-Benz",
          "BMW",
          "Audi",
          "Opel",
          "Ford",
          "Peugeot",
          "Renault",
          "CitroÃ«n",
          "Fiat",
          "Skoda",
          "Seat",
          "Kia",
          "Hyundai",
          "Nissan",
          "Volvo",
          "Mazda",
          "Mitsubishi",
          "Tesla",
          "Jeep",
          "Mini",
          "Dacia",
          "Suzuki",
          "Porsche",
          "Land Rover",
          "Jaguar",
          "Alfa Romeo",
          "Honda",
          "Chevrolet",
          "Chrysler",
          "Dodge",
          "RAM",
          "GMC",
          "Cadillac",
          "Buick",
          "Subaru",
          "Lexus",
          "Infiniti",
          "Acura",
          "Ferrari",
          "Lamborghini",
          "Maserati",
          "Bentley",
          "Rolls-Royce",
          "Aston Martin",
          "McLaren",
          "Bugatti",
          "Genesis",
          "Polestar",
          "Cupra",
          "DS Automobiles",
        ],
      },
      {
        name: "board_number",
        label: "transportConfigs.car.fields.board_number",
        type: "text",
      },
      {
        name: "making_year",
        label: "transportConfigs.car.fields.making_year",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.car.fields.item_weight",
        type: "number",
      },
    ],
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: true,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: true,
  },

  // moving
  {
    type: "moving",
    title: "transportConfigs.moving.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.moving.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Umzugskarton",
          "Kiste",
          "Box",
          "Kleidungskarton",
          "Koffer",
          "Tasche",
          "Rucksack",
          "Schrank",
          "Kleiderschrank",
          "Kommode",
          "Bett",
          "Matratze",
          "Nachttisch",
          "Sofa",
          "Sessel",
          "Stuhl",
          "Tisch",
          "Esstisch",
          "Wohnzimmertisch",
          "Schreibtisch",
          "Regal",
          "Fernsehschrank",
          "Spiegel",
          "Teppich",
          "Bilderrahmen",
          "Dekoration",
          "Lampen",
          "Fernseher",
          "Computer",
          "Monitor",
          "Küchengeräte",
          "Geschirr",
          "Mikrowelle",
          "Staubsauger",
          "Blumentöpfe",
          "Gartenmöbel",
          "Werkzeugkiste",
          "Kleine Möbelstücke",
          "Karton mit Haushaltsartikeln",
          "Waschmaschine",
          "Kühlschrank",
          "Backofen",
          "Komplette Küche",
          "Komplettes Schlafzimmer",
          "Komplettes Wohnzimmer",
          "Komplettes Kinderzimmer",
          "Ganzes Haus oder Wohnung",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.moving.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.moving.fields.item_weight",
        type: "number",
      },
      // {
      //   name: "item_length",
      //   label: "transportConfigs.moving.fields.item_length",
      //   type: "number",
      // },
      // {
      //   name: "item_width",
      //   label: "transportConfigs.moving.fields.item_width",
      //   type: "number",
      // },
      // {
      //   name: "item_height",
      //   label: "transportConfigs.moving.item_height",
      //   type: "number",
      // },
    ],
    hasDimensions: true,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: true,
    hasFloors: true,
    hasDriving: false,
  },

  // bicycle
  {
    type: "bicycle",
    title: "transportConfigs.bicycle.title",
    fields: [
      {
        name: "item_type",
        label: "transportConfigs.bicycle.fields.item_type",
        type: "select2",
        required: true,
        options: [
          "Fahrrad",
          "E-Bike",
          "Pedelec",
          "Citybike",
          "Trekkingrad",
          "Tourenrad",
          "Mountainbike",
          "Crossbike",
          "Rennrad",
          "Gravelbike",
          "Fixie",
          "Singlespeed",
          "Faltrad",
          "Klappfahrrad",
          "Kinderfahrrad",
          "Jugendfahrrad",
          "Lastenrad",
          "E-Lastenrad",
          "Dreirad",
          "Liegerad",
          "Tandem",
          "Cruiser",
          "Fatbike",
          "BMX",
          "Downhill-Bike",
          "Enduro-Bike",
          "Trial-Bike",
          "Roller",
          "E-Roller",
          "Scooter",
          "E-Scooter",
          "Laufrad",
        ],
      },
      {
        name: "num_items",
        label: "transportConfigs.bicycle.fields.num_items",
        type: "number",
      },
      {
        name: "item_weight",
        label: "transportConfigs.bicycle.fields.total_weight",
        type: "number",
      },
    ],
    hasItemSecret: false,
    hasSignature: false,
    hasDimensions: false,
    hasFragile: false,
    hasSpecialHandling: false,
    hasHelpCarry: false,
    hasFloors: false,
    hasDriving: false,
  },
];
